import { Business } from '@mui/icons-material'
import { CircularProgress, Grid } from '@mui/material'

import { DeviceTableRow } from '../../routes/accounts/components/devices-tab-panel/types'
import { locationsListArray } from '../../utils/helpers'
import { getUseCase } from '../../utils/usecase-matrix'
import FormikDropdown from '../formik-dropdown'
import FormikTextField from '../formik-textfield'

export interface EditDeviceFormValues {
  useCase: string
  location: string
  notes: string
  building: string
  floor: string
}

const DeviceEditFields = ({
  device,
  initialValues,
  folderTheme,
}: {
  device: DeviceTableRow | IDeviceAPIObject
  initialValues: EditDeviceFormValues
  folderTheme: IFolderTheme | undefined
}) => {
  const solutions = device.nodeType.allowedUsecases.sort().map((solution) => ({ id: solution, name: getUseCase(solution).vanity }))
  const locationsList = locationsListArray(folderTheme)
  const locations = locationsList.sort().map((location: string) => ({ id: location, name: location }))

  return (
    <>
      <Grid
        size={12}
        sx={{
          marginBottom: -2,
        }}
      >
        <FormikDropdown name="useCase" label="Solution" defaultValue={initialValues.useCase} required={true} items={solutions} size="medium" />
      </Grid>
      <Grid size={12}>
        {!folderTheme ? (
          <CircularProgress />
        ) : (
          <FormikDropdown
            name="location"
            label="Location"
            defaultValue={initialValues.location}
            required={true}
            items={locations}
            size="medium"
            slotProps={{
              select: {
                MenuProps: {
                  style: {
                    height: '500px',
                  },
                },
              },
            }}
          />
        )}
      </Grid>
      <Grid container={true} size={12} spacing={1}>
        <Grid size={8}>
          <FormikTextField name="building" label="Building" startAdornment={<Business />} />
        </Grid>
        <Grid size={4}>
          <FormikTextField name="floor" label="Floor" />
        </Grid>
      </Grid>
      <Grid size={12}>
        <FormikTextField name="notes" label="Notes" required={true} fullWidth={true} multiline={true} rows={6} />
      </Grid>
    </>
  )
}

export default DeviceEditFields
